module.exports = __webpack_public_path__ + "img/oier-logo.ea223f4a.svg";